<script setup lang="ts">
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons'

const props = defineProps<{
  articleId: string
}>()

const { lawReferenceNodeIds, removeLawIdFromReferences } = useArticleReferences(computed(() => props.articleId))
const { back } = useReadingView('academic-article-view-stack')
</script>

<template>
  <div class="flex flex-col gap-m">
    <span class="text-small font-bold dark:text-white">
      Kilder
    </span>

    <div v-if="lawReferenceNodeIds.length > 0">
      <div class="flex lg:hidden items-center gap-2xs pb-xs">
        <ControlButton size="small" :icon="faArrowLeft" aria-label="Tilbake til artikkelen" class="self-start gap-3xs bg-transparent hover:bg-transparent !p-2xs border rounded-lg border-border-default" @click="back()" />
        <span class="text-xsmall" aria-hidden="true">Tilbake til artikkelen</span>
      </div>
      <template v-for="nodeId in [...lawReferenceNodeIds].reverse()" :key="nodeId">
        <LiteratureArticleReferenceItem :id="nodeId" @remove="removeLawIdFromReferences(nodeId)" />
      </template>
    </div>

    <div v-else class="pt-4xl gap-m flex flex-col items-center">
      <IllustrationNoReferences />
      <p class="text-xsmall max-w-72 text-carbon-500 dark:text-carbon-50 text-center">
        Trykk på en lenke eller ikon for å se kilder eller referanser.
      </p>
    </div>
  </div>
</template>
